import Errors from "./errors";

class Form {

    constructor(data, storage = {}) {
        this.uploadPercentage = 0;
        this.storage = storage;
        this.original = data;
        this.loading = false;
        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    fill(field, value) {
        this[field] = value;
    }

    store(field, value) {
        this.storage[field] = value[field];
    }

    extract(data) {
        for (let field in this.original) {
            let value = data[field];

            if (Array.isArray(value)) {
                value = value.map((item) => item.id);
            } else if (typeof value === "object" && value !== null && !(value instanceof File)) {
                this.fill(field, { ...value });
            } else {
                this.fill(field, value);
            }
        }
    }

    data() {
        let data = {};
        for (let field in this.original) {
            let value = this['_formatted_' + field];

            if (typeof value === 'function') {
                value = value.call(this);
            } else {
                value = this[field];
            }

            if (typeof value === "object" && value !== null && !(value instanceof File)) {
                data[field] = { ...value };
            } else {
                data[field] = value;
            }
        }
        return data;
    }


    reset() {
        for (let field in this.original) {
            this[field] = typeof this.original[field] === "object" && !(this.original[field] instanceof File) ? {} : '';
        }
    }

    submit(url) {
        this.loading = true;
        this.errors.clear();
        return new Promise((resolve, reject) => {
            window.axios.post(`${window.location.origin}${url}`, this.data())
                .then((e) => {
                    this.onSuccess(e);
                    resolve(e);
                })
                .catch((e) => {
                    this.onFail(e);
                    reject(e);
                })
                .finally(() => {
                    this.uploadPercentage = 0;
                    this.loading = false;
                });
        });
    }

    upload(url) {
        this.loading = true;
        this.errors.clear();
        let formData = new FormData();

        for (let field in this.original) {
            let value = this[field];

            if (value instanceof File || value instanceof Blob) {
                formData.append(field, value);
            } else if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
                value.forEach((file, index) => {
                    formData.append(`${field}[${index}]`, file);
                });
            } else if (typeof value === "object" && value !== null) {
                try {
                    formData.append(field, JSON.stringify(value));
                } catch (e) {
                    console.warn(`Could not stringify field ${field}`, value);
                }
            } else {
                formData.append(field, value);
            }
        }

        return new Promise((resolve, reject) => {
            window.axios.post(`${window.location.origin}${url}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function (progressEvent) {
                    this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                }.bind(this)
            })
                .then((e) => {
                    this.uploadPercentage = 0;
                    this.loading = false;
                    this.onSuccess(e);
                    resolve(e);
                })
                .catch((e) => {
                    this.uploadPercentage = 0;
                    this.loading = false;
                    this.onFail(e);
                    reject(e);
                });
        });
    }


    onSuccess(e) {
        // Handle success logic if needed
    }

    onFail(e) {
        this.errors.record(e.response?.data?.errors || {});
    }
}

export default Form;
